<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expenses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      expense_ledger: [],
      title: "Expenses",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expenses",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.item_name",
          sortable: true,
          label: "Item Name",
        },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
           {
          key: "expense_date",
          sortable: true,
          label: "EXPENSE DATE",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "expense_details",
          sortable: true,
          label: "Ledger",
        },
        {
          key: "payee_field",
          sortable: true,
          label: "RECEIVER",
        },
        {
          key: "addedBy.name",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE/TIME",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // Value from user input for adding category
      data: {
        payee: "",
        payeeType: "",
        category: "",
        item:"",
        required: "",
        paid: "",
        mode: "",
        date:moment(new Date()).format("YYYY-MM-DD"),
      },
      // edit category
      editdata: {
        payee: "",
        staff: "",
        payeeType: "",
        id: "",
        category: "",
        item:"",
        required: "",
        paid: "",
        date:""
      },
      // Pay balance
      cleardata: {
        balance: "",
        amount: "",
        id: "",
        mode: "",
      },
      // make inputs required
      payeeError: "",
      payeeTypeError: "",
      categoryError: "",
      itemError:"",
      requiredError: "",
      paidError: "",
      modeError: "",
      // delete category
      deletedata: {
        payee: "",
        id: "",
      },
      amountError: "",
      PayeeTypeOptions: [
        {
          id: 1,
          val: "Staff",
        },
        {
          id: 2,
          val: "Non Staff",
        },
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("expense", [
      "Expenses",
      "ExpenseSaveStatus",
      "ExpenseCategories",
      "ExpenseItems"
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("payments", ["PaymentModes"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Expenses ? this.Expenses.length : 1;
    },

     expenseCategoryItem: function () {
      if (this.ExpenseItems) {
        return this.ExpenseItems.filter((item) => {
          return item.category_id == this.data.category;
        });
      } else {
        return [];
      }

    },
    expenseCategoryItemEdit: function () {
      if (this.ExpenseItems) {
        return this.ExpenseItems.filter((item) => {
          return item.category_id == this.editdata.category;
        });
      } else {
        return [];
      }

    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Expenses ? this.Expenses.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeModal(this.modal_id);
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expense/fetchExpenses",
       FetchExpenseItems: "expense/fetchExpenseItems",
      AddExpenditure: "expense/recordExpense",
      EditExpenditure: "expense/editExpenses",
      ClearExpenditure: "expense/clearExpenses",
      DeleteExpense: "expense/deleteExpense",
      FetchExpenseCategories: "expense/fetchExpenseCategories",
      FetchStaff: "staffModule/fetchClinicStaff",
      FetchModes: "payments/fetchPaymentModes",
    }),

    showLedgerModal(data) {
      this.expense_ledger = data.item.expense_details;
    },
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addExpense(modalId) {
      this.modal_id = modalId;

      if (this.data.payee === "") {
        this.payeeError = "Payee field is required";
        return;
      } else {
        this.payeeError = "";
      }
      if (this.data.category === "") {
        this.categoryError = "Expense Category is required";
        return;
      } else {
        this.categoryError = "";
      }
        if (this.data.item === "") {
        this.itemError = "Expense Item is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.required === "") {
        this.requiredError = "Total Expense Amount is required";
        return;
      } else {
        this.requiredError = "";
      }
      if (this.data.paid === "") {
        this.paidError = "Amount Paid is required";
        return;
      } else {
        this.paidError = "";
      }
      if (this.data.payeeType === "") {
        this.payeeTypeError = "Payee Type is required";
        return;
      } else {
        this.payeeTypeError = "";
      }
      if (this.data.mode === "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }

      this.AddExpenditure(this.data);
    },

    resetAddExp() {
      this.data.payee = "";
      this.data.payeeType = "";
      this.data.required = "";
      this.data.category = "";
      this.data.id = "";
      this.data.paid = "";
      this.payeeError = "";
      this.payeeTypeError = "";
      this.requiredError = "";
      this.paidError = "";
      this.categoryError = "";
      this.modal_id = "";
    },
    resetEditExp() {
      this.editdata.payee = "";
      this.editdata.staff = "";
      this.editdata.payeeType = "";
      this.editdata.required = "";
      this.editdata.category = "";
      this.editdata.item = "";
      this.editdata.id = "";
      this.editdata.paid = "";
      this.modal_id = "";
    },

    resetDeleteExp() {
      this.deletedata.payee = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetClearExp() {
      this.cleardata.balance = "";
      this.cleardata.amount = "";
      this.cleardata.id = "";
      this.modal_id = "";
      this.amountError = "";
    },

    resetErrors() {
      this.payeeError = "";
      this.payeeTypeError = "";
      this.requiredError = "";
      this.paidError = "";
      this.categoryError = "";
      this.modeError = "";
      this.amountError = "";
    },
    showEditModal(data) {
      this.editdata.payee = data.item.payee;
      this.editdata.staff = data.item.payee.id;
      this.editdata.payeeType = data.item.payeeType;
      this.editdata.id = data.item.id;
      this.editdata.category = data.item.item.expense_category_id;
      this.editdata.item = data.item.item.id;
      this.editdata.required = data.item.amount;
      this.editdata.paid = data.item.amount - data.item.balance;
    },
    showClearModal(data) {
      this.cleardata.balance = data.item.balance;
      this.cleardata.amount = data.item.balance;
      this.cleardata.id = data.item.id;
    },
    editExpense(modalId) {
      this.modal_id = modalId;
      this.EditExpenditure(this.editdata);
    },
    clearExpBalance(modalId) {
      this.modal_id = modalId;
      if (parseInt(this.cleardata.amount) > parseInt(this.cleardata.balance)) {
        this.amountError =
          this.cleardata.amount +
          " is greater than balance of " +
          this.cleardata.balance;
        return;
      } else {
        this.amountError = "";
      }
      if (this.cleardata.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.cleardata.amount == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      this.ClearExpenditure(this.cleardata);
    },
    showDeleteModal(data) {
      this.deletedata.payee = data.item.payee;
      this.deletedata.id = data.item.id;
    },
    deleteExpenses(modalId) {
      this.modal_id = modalId;
      this.DeleteExpense(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchExpenses();
    this.FetchExpenseCategories();
    this.FetchStaff();
    this.FetchExpenseItems();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-button
                  v-if="user_permissions.record_expense"
                  class="float-end"
                  variant="primary"
                  v-b-modal.add-expense-modal
                  ><i class="fa fa-plus"></i> Record Expense</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Expenses ? Expenses : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(expense_details)="data">
                  <button
                    v-b-modal.modal-ledger
                    @click="showLedgerModal(data)"
                    class="btn btn-success m-2 btn-sm"
                  >
                    View
                  </button>
                </template>
                <template #cell(balance_field)="data">
                  {{ thousandSeprator(data.item.balance) }}
                  <button
                    v-if="
                      data.item.balance > 0 && user_permissions.record_expense
                    "
                    v-b-modal.modal-clear
                    @click="showClearModal(data)"
                    class="btn btn-success m-2 btn-sm"
                  >
                    Clear
                  </button>
                </template>
                <template #cell(payee_field)="data">
                  {{
                    data.item.payeeType == 1
                      ? data.item.payee.staff_name
                      : data.item.payee
                  }}
                </template>
                <template #cell(amount_field)="data">
                  {{ thousandSeprator(data.item.amount) }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    v-if="user_permissions.edit_expense"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-expense-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-else
                    disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-expense-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-if="user_permissions.delete_expense"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-expense-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button
                    v-else
                    disabled
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-expense-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!Expenses" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add expense modal starts -->
            <b-modal id="add-expense-modal" hide-footer @hidden="resetAddExp">
              <template #modal-title> Record New Expense</template>
               <div class="form-group mb-3">
                <label>Expense Items</label>
                <input type="date" v-model="data.date" class="form-control" />
                </div>
              <div class="form-group mb-3">
                <label>Expense Category</label>
                <model-list-select
                  :list="ExpenseCategories ? ExpenseCategories : []"
                  v-model="data.category"
                  option-value="id"
                  option-text="categoryName"
                  class="mb-3"
                  placeholder="Select Expense Category"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="categoryError">
                  <em>{{ categoryError }}</em>
                </div>
              </div>
               <div class="form-group mb-3" v-show="data.category">
                <label>Expense Items</label>
            
                     <input
                       @input="resetErrors()"
                        v-model="data.item"
                        class="form-control"
                        list="datalistOptions"
                        id="exampleDataList"
                        placeholder="Enter patient name"
                        autocomplete="off"
                      />
                      <datalist id="datalistOptions">
                        <option
                          v-for="(item, index) in expenseCategoryItem"
                          :data-value="item.id"
                          :key="index"
                        >
                          {{
                            item.itemName
                          }}
                        </option>
                      </datalist>
                <div class="text-danger" v-if="categoryError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Payee Type</label>
                <model-list-select
                  :list="PayeeTypeOptions"
                  v-model="data.payeeType"
                  option-value="id"
                  option-text="val"
                  class="mb-3"
                  placeholder="Select Expense Category"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="payeeTypeError">
                  <em>{{ payeeTypeError }}</em>
                </div>
              </div>
              <div v-if="data.payeeType == 1" class="form-group mb-3">
                <label>Payee</label>
                <model-list-select
                  :list="clinic_staff ? clinic_staff : []"
                  v-model="data.payee"
                  option-value="id"
                  option-text="staffName"
                  class="mb-3"
                  placeholder="Select Payee"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="payeeError">
                  <em>{{ payeeError }}</em>
                </div>
              </div>
              <div v-else class="form-group mb-3">
                <label>Payee</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.payee"
                    @input="resetErrors()"
                  />
                </div>
                <div class="text-danger" v-if="payeeError">
                  <em>{{ payeeError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Expense Amount</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.required"
                    @input="resetErrors()"
                    placeholder="Total Amount"
                  />
                </div>
                <div class="text-danger" v-if="requiredError">
                  <em>{{ requiredError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount Paid</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.paid"
                    @input="resetErrors()"
                    placeholder="Amount Paid"
                  />
                </div>
                <div class="text-danger" v-if="paidError">
                  <em>{{ paidError }}</em>
                </div>
              </div>
              <div class="form-group">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentModes ? PaymentModes : []"
                  v-model="data.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addExpense('add-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Expense
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- add expense modal starts -->
            <b-modal id="modal-ledger" hide-footer @hidden="resetAddExp">
              <template #modal-title> Record New Expense</template>

              <div class="container">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Paid</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in expense_ledger" :key="i">
                      <td>{{ item.date }}</td>
                      <td>{{ item.amount }}</td>
                      <td>{{ item.balance }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-expense-modal" hide-footer @hidden="resetEditExp">
              <template #modal-title>
                Edit Expense of {{ editdata.amount }}</template
              >
              <div class="form-group mb-3">
                <label>Expense Category</label>
                <model-list-select
                  :list="ExpenseCategories ? ExpenseCategories : []"
                  v-model="editdata.category"
                  option-value="id"
                  option-text="categoryName"
                  class="mb-3"
                  placeholder="Select Expense Category"
                >
                </model-list-select>
              </div>
               <div class="form-group mb-3" v-show="editdata.category">
                <label>Expense Items</label>
                <model-list-select
                  :list="expenseCategoryItemEdit ? expenseCategoryItemEdit : []"
                  v-model="editdata.item"
                  option-value="id"
                  option-text="itemName"
                  class="mb-3"
                  placeholder="Select Expense Item"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="categoryError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div v-if="editdata.payeeType == 1" class="form-group mb-3">
                <label>Payee</label>
                <model-list-select
                  :list="clinic_staff ? clinic_staff : []"
                  v-model="editdata.staff"
                  option-value="id"
                  option-text="staffName"
                  class="mb-3"
                  placeholder="Select Payee"
                >
                </model-list-select>
              </div>
              <div v-else class="form-group mb-3">
                <label>Payee</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.payee"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Expense Amount</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="editdata.required"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Amount Paid</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="editdata.paid"
                  />
                </div>
                <div class="text-danger" v-if="paidError">
                  <em>{{ paidError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editExpense('edit-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-expense-modal"
              hide-footer
              @hidden="resetDeleteExp"
            >
              <template #modal-title> Delete Expenditure</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this expense? This is a permanent
                    action.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteExpenses('delete-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- modal for clearing balance -->
            <div>
              <b-modal
                id="modal-clear"
                title="Clear Expense Balance"
                hide-footer
                @hidden="resetClearExp"
              >
                <div class="form-group">
                  <label>Amount Paid</label>
                  <input
                    @input="resetErrors()"
                    type="number"
                    class="form-control"
                    v-model="cleardata.amount"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
                <div class="form-group">
                  <label>Payment Method</label>
                  <model-list-select
                    :list="PaymentModes ? PaymentModes : []"
                    v-model="cleardata.mode"
                    option-value="id"
                    option-text="mode"
                    placeholder="Select Method"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
                <div class="modal-footer mt-3">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('modal-clear')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="clearExpBalance('modal-clear')"
                  >
                    <i class="fa fa-arrow-right"></i> Clear
                    <b-spinner
                      v-if="ExpenseSaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
            </div>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
